// Pagination.js
import React from "react";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  return (
    <div className="flex justify-between items-center mt-4">
      <button
        onClick={handlePrevPage}
        disabled={currentPage === 1}
        className="bg-gray-500 text-white px-4 py-2 rounded disabled:opacity-100"
      >
        Prev
      </button>
      <span className="text-blue-400 font-semibold text-lg">
        Pagina {currentPage} din {totalPages}
      </span>      <button
        onClick={handleNextPage}
        disabled={currentPage === totalPages}
        className="bg-gray-500 text-white px-4 py-2 rounded disabled:opacity-100"
      >
        Next
      </button>
    </div>
  );
};

export default Pagination;
